import { OpenNewTabTargetType, } from '@voltmoney/types';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ACTION } from './types';
import { ROUTE } from '../../routes';
import { PartnerAccountType, } from '../../configs/constants';
import { addCommasToNumber, addYearToEpochTime, getParamsLink, maskSensitiveDetails, partnerRouteConfig, showMFDLedJourney, showPhoneNumber, showTableActions, showViewDetails } from '../../configs/utils';
import { partnerApi } from '../../configs/api';
import { getAppHeader } from "../../configs/config";
import { showShareLink } from "../../configs/uri-config-utils";
import AsyncStorage from '@react-native-async-storage/async-storage';
import sharedPropsService from "../../SharedPropsService";
const routerData = {
    "dashboard": "/partner/dashboard",
    "pendingApplications": "/partner/leads",
    "capitalGain": "/partner/capitalGain",
    "customer": "/partner/customer",
    "interestCalculator": "/partner/interest-calculator",
    "referredPartner": "/partner/referredpartner",
    "earning": "/partner/earning",
    "freeEligibilityCheck": "/partner/free-eligibility-check",
    "viewCustomerPortfolio": "/partner/view-customer-portfolio",
    "collateral": "/partner/collateral",
    "demoVideos": "/partner/demo_videos",
    "myAccount": "/partner/my_account"
};
export const TableDataBuilder = (mockDATA, partnerAccountType, partnerUserContext) => {
    let DATA = {
        // selectMap: [],
        name: [],
        phoneNumber: [],
        totalPortfolioAmount: [],
        availableCreditAmount: [],
        currentStepName: [],
        customerJourney: []
    };
    if (partnerAccountType &&
        partnerAccountType === PartnerAccountType.INDIVIDUAL) {
        DATA = {
            ...DATA,
            lastUpdatedOn: [],
            customerJourney: [],
        };
    }
    else {
        DATA = {
            ...DATA,
            lastUpdatedOn: [],
            customerJourney: [],
        };
    }
    const Title_MAP = {
        // selectMap: '',
        name: 'Name',
        panNumber: 'PAN',
        phoneNumber: 'Mobile',
        emailId: 'Email',
        currentStepName: 'Application status',
        createdOn: 'Created on',
    };
    let DATA_STORE = {};
    let TITLE_CONFIG = {
        // selectMap: {
        //     title: '',
        //     flex: 1,
        //     cellMaxWidth: 48,
        // },
        name: {
            title: 'NAME\n\n\n',
            flex: 2,
            cellMinWidth: 144,
        },
        phoneNumber: {
            title: 'MOBILE\n\n\n',
            flex: 1,
            cellMinWidth: 112,
        },
        currentStepName: {
            title: 'STATUS\n\n\n',
            flex: 1,
            cellMinWidth: 96,
        },
        // totalPortfolioAmount: {
        //     title: 'Portfolio fetched (in Rs.)',
        //     flex: 3,
        //     cellMinWidth: 100,
        // },
        availableCreditAmount: {
            title: 'AVAILABLE CREDIT AMOUNT',
            flex: 1,
            cellMinWidth: 96,
        },
        // createdOn: {
        //     title: 'Created on',
        //     flex: 2,
        //     cellMinWidth: 96,
        // },
        // lastUpdatedOn: {
        //     title: 'Last updated',
        //     flex: 2,
        //     cellMinWidth: 96,
        // },
        // customerJourney: {
        //     title: 'Customer journey',
        //     flex: 2,
        //     cellMinWidth: 96,
        // }
    };
    if (partnerAccountType &&
        partnerAccountType === PartnerAccountType.INDIVIDUAL) {
        TITLE_CONFIG = {
            ...TITLE_CONFIG,
            lastUpdatedOn: {
                title: 'LAST UPDATED\n\n',
                flex: 1,
                cellMinWidth: 96,
            },
            customerJourney: {
                title: 'ACTION',
                flex: 3,
                cellMinWidth: 120,
            },
        };
    }
    else {
        TITLE_CONFIG = {
            ...TITLE_CONFIG,
            lastUpdatedOn: {
                title: 'LAST UPDATED',
                flex: 1,
                cellMinWidth: 96,
            },
            ...(showTableActions(partnerAccountType) ? {
                customerJourney: {
                    title: 'ACTION',
                    flex: 3,
                    cellMinWidth: 120,
                }
            } : {}),
        };
    }
    console.log('*** mockDATA ***: ', mockDATA);
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        tableObject = {
            name: item?.borrowerAccountProfile.name
                ? item?.borrowerAccountProfile.name
                : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber
                ? item?.borrowerAccountProfile?.phoneNumber
                : '',
            totalPortfolioAmount: item?.assetDetails.totalPortfolioAmount | 0,
            availableCreditAmount: item?.assetDetails.availableCreditAmount | 0,
            currentStepName: item.currentStepName ? item.currentStepName : '',
            createdOn: item?.lastUpdatedOn,
            lastUpdatedOn: item?.lastUpdatedOn,
            // customerJourney: item?.borrowerAccountProfile.userId,
            customerJourney: item,
        };
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'selectMap') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.RADIO,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        isChecked: false,
                        size: IconSizeTokens.MD,
                        actionChecked: {
                            type: ACTION.ON_SELECT,
                            routeId: ROUTE.PARTNER_LEAD,
                            payload: { data: item },
                        },
                        actionUnChecked: {
                            type: ACTION.ON_SELECT,
                            routeId: ROUTE.PARTNER_LEAD,
                            payload: { data: item },
                        },
                    },
                };
            }
            else if (fieldName === 'currentStepName') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        // bgColor: ColorTokens.Grey_Chalk,
                        // justifyContent: StackJustifyContent.flexStart,
                        // alignItems: StackAlignItems.center,
                        borderConfig: {
                            borderRadius: BorderRadiusTokens.BR1,
                        },
                        // padding: {
                        //     vertical: SizeTypeTokens.MD,
                        //     left: SizeTypeTokens.MD,
                        // },
                        widgetItems: [
                            // { id: `icon_${fieldName}_${index_i}`, type: WIDGET.ICON },
                            // { id: `leads_status_space_${fieldName}_${index_i}`, type: WIDGET.SPACE },
                            {
                                id: `statusTitle_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    // [`leads_status_space_${fieldName}_${index_i}`]: <SpaceProps>{
                    //     size: SizeTypeTokens.MD
                    // },
                    // [`icon_${fieldName}_${index_i}`]:<IconProps> {
                    //     name: IconTokens.Dot,
                    //     label: IconTokens.Dot,
                    //     size: IconSizeTokens.XXL
                    // },
                    [`statusTitle_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'totalPortfolioAmount' ||
                fieldName === 'availableCreditAmount') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        justifyContent: StackJustifyContent.flexEnd,
                        alignItems: StackAlignItems.center,
                        widgetItems: [
                            {
                                id: `amountLeads_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    [`amountLeads_${fieldName}_${index_i}`]: {
                        label: `₹${addCommasToNumber(tableObject[fieldName])}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'createdOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'lastUpdatedOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'phoneNumber') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: showPhoneNumber(partnerAccountType) ?
                            `${tableObject[fieldName]}`.slice(3) :
                            `${maskSensitiveDetails(`${tableObject[fieldName]}`.slice(3), 0, 4)}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'customerJourney') {
                const _user = tableObject[fieldName];
                const currentStepName = _user?.currentStepName;
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.column,
                        alignItems: StackAlignItems.flexStart,
                        justifyContent: StackJustifyContent.center,
                        padding: {
                            top: SizeTypeTokens.XS,
                            left: SizeTypeTokens.XS,
                            bottom: SizeTypeTokens.XS,
                        },
                        widgetItems: [
                            partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL ? {
                                id: `trackbutton_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            } : {},
                            partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL ? {
                                id: `viewDetail_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            } : {},
                            (currentStepName !== "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) && showShareLink(partnerUserContext) ? {
                                id: `shareLink_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            } : {},
                        ],
                    },
                    [`trackbutton_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        widgetItems: [
                            { id: `trackbutton_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        action: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ?
                            {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: ACTION.ON_REGISTER_LEADS,
                                payload: {
                                    isPrevRouteLeads: true,
                                    preFill: true,
                                    pan: _user?.borrowerAccountProfile?.panNumber,
                                    phoneNumber: _user?.borrowerAccountProfile?.phoneNumber.slice(3)
                                },
                            }
                            : {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                                payload: {
                                    value: tableObject[fieldName],
                                },
                            },
                    },
                    [`shareLink_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        widgetItems: [
                            { id: `shareLink_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        action: {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: ACTION.SHARE_LINK,
                            payload: {
                                user: tableObject[fieldName],
                            },
                        },
                    },
                    [`viewDetail_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        widgetItems: [
                            { id: `viewDetails_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        action: {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: (currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) ? ACTION.CHECK_LIMIT_VIEW_DETAILS : ACTION.VIEW_DETAILS,
                            payload: {
                                user: tableObject[fieldName],
                            },
                        },
                    },
                    [`trackbutton_${fieldName}_${index_i}`]: {
                        label: currentStepName !== "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ? `Complete application \u276F` : `Register customer \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                    [`shareLink_${fieldName}_${index_i}`]: {
                        label: `Share link \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                    [`viewDetails_${fieldName}_${index_i}`]: {
                        label: `View details \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
export const ActiveCustomerTableBuilder = (mockDATA, partnerAccountType) => {
    let DATA = {
        // selectMap: [],
        name: [],
        phoneNumber: [],
        totalValueOfAssetsPledged: [],
        approvedCreditAmount: [],
        principalOutStandingAmount: [],
        overUtilizationAmount: [],
        availableCreditAmount: []
    };
    if (showMFDLedJourney(partnerAccountType)) {
        DATA = {
            ...DATA,
            customerJourney: [],
        };
    }
    else {
        DATA = {
            ...DATA,
            customerJourney: [],
        };
    }
    const Title_MAP = {
        // selectMap: '',
        name: 'Name',
        totalPortfolioAmount: 'Portfolio Amount',
        approvedCreditAmount: 'Sanction Limit',
        // needs to be make a extra field for this
        limitIncreaseAvailable: 'Limit Increase Available',
        // should be default zero
        principalOutStandingAmount: 'Withdrawn amount',
        availableCreditAmount: 'Available amount for disbursement',
        createdOn: 'Contract Start Date',
        expiresOn: 'Contract End Date',
    };
    let TITLE_CONFIG = {
        // selectMap: {
        //     title: '',
        //     flex: 1,
        //     cellMaxWidth: 48,
        // },
        name: {
            title: 'NAME',
            flex: 2,
            cellMinWidth: 144,
        },
        // needs to be make a extra field for this
        phoneNumber: {
            title: 'MOBILE',
            flex: 1,
            cellMinWidth: 112,
        },
        approvedCreditAmount: {
            title: 'TOTAL CREDIT LIMIT',
            flex: 2,
            cellMinWidth: 80,
        },
        availableCreditAmount: {
            title: 'AVAILABLE CREDIT LIMIT',
            flex: 2,
            cellMinWidth: 80,
        },
        // totalValueOfAssetsPledged: {
        //     title: 'Portfolio pledged (in Rs.)',
        //     flex: 1,
        //     cellMinWidth: 80,
        // },
        principalOutStandingAmount: {
            title: 'OUTSTANDING AMOUNT',
            flex: 2,
            cellMinWidth: 80,
        },
        // overUtilizationAmount: {
        //     title: 'Overutilization amount',
        //     flex: 2,
        //     cellMinWidth: 80,
        // },
        // renewalDate: {
        //     title: 'Contract End Date',
        //     flex: 1,
        //     cellMinWidth: 96,
        // },
    };
    if (showMFDLedJourney(partnerAccountType)) {
        TITLE_CONFIG = {
            ...TITLE_CONFIG,
            customerJourney: {
                title: 'ACTION',
                flex: 2,
                cellMinWidth: 112,
            },
        };
    }
    else {
        TITLE_CONFIG = {
            ...TITLE_CONFIG,
            customerJourney: {
                title: 'ACTION',
                flex: 2,
                cellMinWidth: 112,
            },
        };
    }
    let DATA_STORE = {};
    console.log('*** mockDATA ***: ', mockDATA);
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        tableObject = {
            name: item?.borrowerAccountProfile?.name
                ? item?.borrowerAccountProfile?.name
                : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
            totalValueOfAssetsPledged: item?.credit?.totalValueOfAssetsPledged | 0,
            approvedCreditAmount: item?.credit?.approvedCreditAmount | 0,
            principalOutStandingAmount: item?.credit?.principalOutStandingAmount | 0,
            overUtilizationAmount: Math.min(item?.credit?.availableCreditAmount, 0) | 0,
            renewalDate: item?.credit.renewalDate,
            availableCreditAmount: item?.credit?.availableCreditAmount,
            customerJourney: item,
        };
        console.log('table Object: ', tableObject);
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'selectMap') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.RADIO,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        isChecked: false,
                        size: IconSizeTokens.MD,
                        actionChecked: {
                            type: ACTION.ON_SELECT_AC,
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            payload: { data: item },
                        },
                        actionUnChecked: {
                            type: ACTION.ON_SELECT_AC,
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            payload: { data: item },
                        },
                    },
                };
            }
            else if (fieldName === 'totalValueOfAssetsPledged' ||
                fieldName === 'approvedCreditAmount' ||
                fieldName === 'principalOutStandingAmount' ||
                fieldName === 'overUtilizationAmount' ||
                fieldName === 'availableCreditAmount') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        justifyContent: StackJustifyContent.flexEnd,
                        alignItems: StackAlignItems.center,
                        widgetItems: [
                            {
                                id: `AC_AmountStack_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    [`AC_AmountStack_${fieldName}_${index_i}`]: {
                        label: `₹${addCommasToNumber(tableObject[fieldName])}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'createdOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'renewalDate') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'phoneNumber') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: showPhoneNumber(partnerAccountType) ? `${tableObject[fieldName]}`.slice(3) : `${maskSensitiveDetails(`${tableObject[fieldName]}`.slice(3), 0, 4)}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'customerJourney') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        type: StackType.column,
                        alignItems: StackAlignItems.flexStart,
                        justifyContent: StackJustifyContent.center,
                        padding: {
                            top: SizeTypeTokens.XS,
                            left: SizeTypeTokens.XS,
                            bottom: SizeTypeTokens.XS,
                        },
                        widgetItems: [
                            (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? {
                                id: `AC_trackbutton_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            } : {},
                            {
                                id: `AC_shareLink_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            },
                            {
                                id: `AC_viewDetail_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            },
                        ],
                        // action: {
                        //     routeId: ROUTE.PARTNER_LEAD,
                        //     type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                        //     payload: {
                        //         value: tableObject[fieldName],
                        //     },
                        // },
                    },
                    [`AC_trackbutton_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        widgetItems: [
                            { id: `AC_trackbutton_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        action: {
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                            payload: {
                                value: tableObject[fieldName],
                            },
                        },
                    },
                    [`AC_viewDetail_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        widgetItems: [
                            { id: `AC_viewDetails_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        action: {
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: tableObject[fieldName],
                            },
                        },
                    },
                    [`AC_trackbutton_${fieldName}_${index_i}`]: {
                        label: `View as client \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                    [`AC_viewDetails_${fieldName}_${index_i}`]: {
                        label: `View details \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
export const ReferredPartnerTableBuilder = (mockDATA) => {
    const DATA = {
        // selectMap: [],
        partnerName: [],
        partnerMobileNumber: [],
        partnerActivationStatus: [],
        empanelmentDate: []
    };
    const Title_MAP = {
        // selectMap: '',
        partnerName: 'Name',
        partnerMobileNumber: 'Portfolio Amount',
        partnerActivationStatus: 'Status',
        empanelmentDate: 'Date of empanelment'
    };
    const TITLE_CONFIG = {
        // selectMap: {
        //     title: '',
        //     flex: 1,
        //     cellMaxWidth: 48,
        // },
        partnerName: {
            title: 'MFD name',
            flex: 1,
            // cellMinWidth: 144,
            // cellMaxWidth: 200,
        },
        partnerMobileNumber: {
            title: 'Phone',
            flex: 1,
            // cellMinWidth: 112,
            // cellMaxWidth: 200,
        },
        partnerActivationStatus: {
            title: 'Status',
            flex: 1,
            // cellMinWidth: 144,
            // cellMaxWidth: 200,
        },
        empanelmentDate: {
            title: 'Date of empanelment',
            flex: 1,
            // cellMinWidth: 144,
        }
    };
    let DATA_STORE = {};
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        tableObject = {
            partnerName: item?.partnerName ? item?.partnerName : '',
            partnerMobileNumber: item?.partnerMobileNumber
                ? item?.partnerMobileNumber
                : '',
            partnerActivationStatus: item?.partnerActivationStatus,
            empanelmentDate: item?.empanelmentDate
        };
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'partnerMobileNumber') {
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`.slice(3),
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'empanelmentDate') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
/**
 @description function to search string value in object property
 **/
export const searchObject = (obj, searchString) => {
    const results = [];
    obj &&
        Object.keys(obj).forEach((key, index) => {
            const value = obj[key];
            // Check if the value is an object and recursively search it
            if (typeof value === 'object') {
                results.push(...searchObject(value, searchString));
            }
            // If the value is a string and contains the search string, add it to the results array
            if (checkIfFieldIsValid(key) &&
                typeof value === 'string' &&
                value.toLowerCase().includes(searchString.toLowerCase())) {
                results.push(value);
            }
        });
    return results;
};
export const convertISODate = (timeString) => {
    // timeString = "2023-02-28T10:30:52.119Z";
    const dateObj = new Date(timeString);
    const date = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const year = dateObj.toLocaleDateString('en-US', { year: 'numeric' });
    return { date, month, year };
};
export const sortPartnerObjectByProperty = (objects, propertyName, asc) => {
    return objects.sort(function (a, b) {
        if (propertyName === 'createdOn' ||
            propertyName === 'applicationState' ||
            propertyName === 'lastUpdatedOn') {
            if (a?.creditApplication[propertyName] <
                b?.creditApplication[propertyName]) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        else if (propertyName === 'phoneNumber' || propertyName === 'name') {
            if (a?.borrowerAccountProfile[propertyName] <
                b?.borrowerAccountProfile[propertyName]) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        else if (propertyName === 'totalPortfolioAmount' ||
            propertyName === 'approvedCreditAmount') {
            if (a?.assetDetails[propertyName] < b?.assetDetails[propertyName]) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        else if (propertyName === 'totalValueOfAssetsPledged' ||
            propertyName === 'approvedCreditAmount' ||
            propertyName === 'principalOutStandingAmount' ||
            propertyName === 'overUtilizationAmount' ||
            propertyName === 'renewalDate') {
            if (a?.credit[propertyName] < b?.credit[propertyName]) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        return 0;
    });
};
export const sortReferredPartnerObjectByProperty = (objects, propertyName, asc) => {
    return objects.sort(function (a, b) {
        if (propertyName === 'partnerName' ||
            propertyName === 'partnerMobileNumber' ||
            propertyName === 'partnerActivationStatus') {
            if (a?.partnerName < b?.partnerName) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
    });
};
// export const sortActiveCustomerObjectsByProperty = (
//     objects: PartnerLeadsType[],
//     propertyName,
//     asc: boolean,
// ) => {
//     return objects.sort(function (a, b) {
//         if (
//             propertyName === 'totalValueOfAssetsPledged' ||
//             propertyName === 'approvedCreditAmount' ||
//             propertyName === 'principalOutStandingAmount' ||
//             propertyName === 'overUtilizationAmount' ||
//             propertyName === 'renewalDate'
//         ) {
//             if (
//                 a?.credit[propertyName] <
//                 b?.credit[propertyName]
//             ) {
//                 return asc ? -1 : 1
//             } else {
//                 return asc ? 1 : -1
//             }
//         } else if (
//             propertyName === 'phoneNumber' ||
//             propertyName === 'name'
//         ) {
//             if (
//                 a?.borrowerAccountProfile[propertyName] <
//                 b?.borrowerAccountProfile[propertyName]
//             ) {
//                 return asc ? -1 : 1
//             } else {
//                 return asc ? 1 : -1
//             }
//         }
//         return 0;
//     });
// }
export const rebuildLeadsTable = async (StandardUtilities, PartnerLeadsData, action, partnerAccountType, partnerUserContext) => {
    await StandardUtilities.setDatastore(action.routeId, 'leadTable', {
        widgetData: {
            ...TableDataBuilder(PartnerLeadsData, partnerAccountType, partnerUserContext).DATA,
        },
        data: PartnerLeadsData,
    });
    const TITLE_CONFIG = TableDataBuilder(PartnerLeadsData, partnerAccountType, partnerUserContext).DATA;
    const TABLE_DATA = TableDataBuilder(PartnerLeadsData, partnerAccountType, partnerUserContext).TABLE_DATA;
    if (PartnerLeadsData && PartnerLeadsData.length > 0) {
        PartnerLeadsData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    console.log('fieldName: ', fieldName);
                    if (fieldName === 'currentStepName') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                {
                                    id: `statusTitle_${fieldName}_${index_i}`,
                                    type: WIDGET.TEXT,
                                },
                            ],
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `statusTitle_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                    else if (fieldName === 'totalPortfolioAmount' ||
                        fieldName === 'availableCreditAmount') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                {
                                    id: `amountLeads_${fieldName}_${index_i}`,
                                    type: WIDGET.TEXT,
                                },
                            ],
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `amountLeads_${fieldName}_${index_i}`, {
                            label: `₹${addCommasToNumber(TABLE_DATA[index_i][fieldName])}`,
                        });
                    }
                    else if (fieldName === 'phoneNumber') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `${fieldName}_${index_i}`, {
                            label: showPhoneNumber(partnerAccountType) ?
                                `${TABLE_DATA[index_i][fieldName]}`.slice(3) :
                                `${maskSensitiveDetails(`${TABLE_DATA[index_i][fieldName]}`.slice(3), 0, 4)}`,
                        });
                    }
                    else if (fieldName === 'createdOn' ||
                        fieldName === 'lastUpdatedOn') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'customerJourney') {
                        const _user = TABLE_DATA[index_i][fieldName];
                        const currentStepName = _user?.currentStepName;
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, [`${fieldName}_${index_i}`], {
                            widgetItems: [
                                { id: `trackbutton_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                                (currentStepName && currentStepName !== "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) && showShareLink(partnerUserContext) ? { id: `shareLink_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK } : {},
                                { id: `viewDetail_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                            ]
                        });
                        // console.log("Table data for led journey: ", TABLE_DATA[index_i][fieldName])
                        // console.log("partnerAccountType: ", partnerAccountType);
                        partnerAccountType &&
                            partnerAccountType === PartnerAccountType.INDIVIDUAL &&
                            StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `trackbutton_Stack_${fieldName}_${index_i}`, {
                                action: currentStepName && currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ?
                                    {
                                        routeId: ROUTE.PARTNER_LEAD,
                                        type: ACTION.ON_REGISTER_LEADS,
                                        payload: {
                                            value: TABLE_DATA[index_i][fieldName],
                                            pan: _user?.borrowerAccountProfile?.panNumber,
                                            phoneNumber: _user?.borrowerAccountProfile?.phoneNumber.slice(3),
                                            preFill: true
                                        },
                                    } :
                                    {
                                        routeId: ROUTE.PARTNER_LEAD,
                                        type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                                        payload: {
                                            value: TABLE_DATA[index_i][fieldName],
                                        },
                                    },
                            });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `shareLink_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: ACTION.SHARE_LINK,
                                payload: {
                                    user: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `trackbutton_${fieldName}_${index_i}`, {
                            label: currentStepName !== "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ? `Complete application \u276F` : `Register customer \u276F`,
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `viewDetail_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: (currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) ?
                                    ACTION.CHECK_LIMIT_VIEW_DETAILS :
                                    ACTION.VIEW_DETAILS,
                                payload: {
                                    user: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
    // if (PartnerLeadsData && PartnerLeadsData.length > 0) {
    //     PartnerLeadsData.map((item, index_i) => {
    //         const borrowerAccountProfile = item?.borrowerAccountProfile
    //         Object.keys(borrowerAccountProfile).map((fieldName, indexY) => {
    //             console.log(
    //                 `${fieldName}_${index_i}: `,
    //                 `${borrowerAccountProfile[fieldName]}`,
    //             )
    //             StandardUtilities.setDatastore(
    //                 ROUTE.PARTNER_DASHBOARD,
    //                 `${fieldName}_${index_i}`,
    //                 <TypographyProps>{
    //                     label: `${borrowerAccountProfile[fieldName]}`,
    //                 },
    //             )
    //         })
    //     })
    // }
    // await StandardUtilities.setDatastore(
    //     ROUTE.PARTNER_LEAD,
    //     'renderWidgetGroup',
    //     <RenderWidgetGroupProps>{
    //         extraProps: { PartnerLeadsData },
    //     },
    // )
};
export const rebuildReferredPartnerTable = async (StandardUtilities, ReferredPartnerData, action) => {
    await StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, 'referredPartnerTable', {
        widgetData: {
            ...ReferredPartnerTableBuilder(ReferredPartnerData).DATA,
        },
        data: ReferredPartnerData,
    });
    const TITLE_CONFIG = ReferredPartnerTableBuilder(ReferredPartnerData).DATA;
    const TABLE_DATA = ReferredPartnerTableBuilder(ReferredPartnerData).TABLE_DATA;
    if (ReferredPartnerData && ReferredPartnerData.length > 0) {
        ReferredPartnerData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    if (fieldName === 'partnerMobileNumber') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, `RP_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`.slice(3),
                        });
                    }
                    else if (fieldName === 'empanelmentDate') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `RP_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, `RP_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
    // await StandardUtilities.setDatastore(
    //     ROUTE.PARTNER_REFERRED_PARTNER,
    //     'renderWidgetGroup',
    //     <RenderWidgetGroupProps>{
    //         extraProps: { ReferredPartnerData },
    //     },
    // )
};
export const rebuildActiveCustomerTable = async (StandardUtilities, PartnerActiveCustomerData, action, partnerAccountType) => {
    await StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, 'activeCustomerTable', {
        widgetData: {
            ...ActiveCustomerTableBuilder(PartnerActiveCustomerData, partnerAccountType).DATA,
        },
        data: PartnerActiveCustomerData,
    });
    const TITLE_CONFIG = ActiveCustomerTableBuilder(PartnerActiveCustomerData, partnerAccountType).DATA;
    const TABLE_DATA = ActiveCustomerTableBuilder(PartnerActiveCustomerData, partnerAccountType).TABLE_DATA;
    if (PartnerActiveCustomerData && PartnerActiveCustomerData.length > 0) {
        PartnerActiveCustomerData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    if (fieldName === 'totalValueOfAssetsPledged' ||
                        fieldName === 'approvedCreditAmount' ||
                        fieldName === 'principalOutStandingAmount' ||
                        fieldName === 'overUtilizationAmount') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_AmountStack_${fieldName}_${index_i}`, {
                            label: `₹${addCommasToNumber(TABLE_DATA[index_i][fieldName])}`,
                        });
                    }
                    else if (fieldName === 'createdOn') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'renewalDate') {
                        const { date, month, year } = convertISODate(addYearToEpochTime(TABLE_DATA[index_i][fieldName], 1));
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'phoneNumber') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_${fieldName}_${index_i}`, {
                            label: showPhoneNumber(partnerAccountType) ? `${TABLE_DATA[index_i][fieldName]}`.slice(3) : `${maskSensitiveDetails(`${TABLE_DATA[index_i][fieldName]}`.slice(3), 0, 4)}`,
                        });
                    }
                    else if (fieldName === 'customerJourney') {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_${fieldName}_${index_i}`, {
                            widgetItems: [
                                (partnerAccountType &&
                                    partnerAccountType === PartnerAccountType.INDIVIDUAL) ? { id: `AC_trackbutton_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK } : {},
                                { id: `AC_viewDetail_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                            ]
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_trackbutton_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                                payload: {
                                    value: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_viewDetail_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                                type: ACTION.VIEW_DETAILS,
                                payload: {
                                    user: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `AC_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
    // await StandardUtilities.setDatastore(
    //     ROUTE.PARTNER_DASHBOARD,
    //     'renderWidgetGroup',
    //     <RenderWidgetGroupProps>{
    //         extraProps: { PartnerActiveCustomerData },
    //     },
    // )
};
export const checkIfFieldIsValid = (key, titleConfig) => {
    if (key === 'name' ||
        key === 'phoneNumber' ||
        key === 'partnerName' ||
        key === 'accountHolderPhoneNumber') {
        return true;
    }
    return false;
};
export const sideBarNavigate = async (standardUtilities, action) => {
    switch (action?.payload?.route || action?.payload?.value || action?.payload?.routeId) {
        case ROUTE.PARTNER_DASHBOARD_V2:
            window.location.href = routerData['dashboard'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_DASHBOARD_V2, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_LEAD:
            window.location.href = routerData['pendingApplications'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_LEAD, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_CAPITAL_GAIN:
            window.location.href = routerData['capitalGain'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_CAPITAL_GAIN, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_ACTIVE_CUSTOMER:
            window.location.href = routerData['customer'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER, {
        //     actionItems: action.payload
        // })    
        case ROUTE.INTEREST_CALCULATOR:
            window.location.href = routerData['interestCalculator'];
            return;
        // return standardUtilities.navigate(ROUTE.INTEREST_CALCULATOR, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_REFERRED_PARTNER:
            window.location.href = routerData['referredPartner'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_REFERRED_PARTNER, {
        //     actionItems: action.payload
        // })
        case ROUTE.EARNING:
            window.location.href = routerData['earning'];
            return;
        // return standardUtilities.navigate(ROUTE.EARNING, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_CHECK_LIMIT:
            window.location.href = routerData['freeEligibilityCheck'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_CHECK_LIMIT, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO:
            window.location.href = routerData['viewCustomerPortfolio'];
            return;
        // return standardUtilities.navigate(ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO, {
        //     actionItems: action.payload
        // })
        case ROUTE.COLLATERAL:
            window.location.href = routerData['collateral'];
            return;
        // return standardUtilities.navigate(ROUTE.COLLATERAL, {
        //     actionItems: action.payload
        // })
        case ROUTE.DEMO_VIDEOS:
            window.location.href = routerData['demoVideos'];
            return;
        // return standardUtilities.navigate(ROUTE.DEMO_VIDEOS, {
        //     actionItems: action.payload
        // })
        case ROUTE.MY_ACCOUNT:
            window.location.href = routerData['myAccount'];
            return;
        // return standardUtilities.navigate(ROUTE.MY_ACCOUNT, {
        //     actionItems: action.payload
        // })
        case ROUTE.PARTNER_MENU:
            return standardUtilities.navigate(ROUTE.PARTNER_MENU, {
                actionItems: action.payload
            });
    }
};
export const navigateByUrl = async (routeName, openNewTab, passQueryParams) => {
    const routeConfig = partnerRouteConfig(routeName);
    if (passQueryParams) {
        const url = window.location.href;
        await openNewTab(`/partner/${routeConfig}/${getParamsLink(url)}`, OpenNewTabTargetType.self);
    }
    else {
        await openNewTab(`/partner/${routeConfig}`, OpenNewTabTargetType.self);
    }
};
const postMessageChildToParent = (message, targetOrigin = '*') => {
    window.parent.postMessage(message, targetOrigin);
};
const postMessageParentToChild = (message, targetOrigin = '*') => {
    const iframe = document.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(message, targetOrigin);
    }
};
const postMessageObserver = (callBack) => {
    window.addEventListener('message', callBack);
};
export const WebViewUtils = {
    postMessageChildToParent,
    postMessageParentToChild,
    postMessageObserver,
};
export const onTrackCustomer = async (userId, network, asyncStorage) => {
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const response = await network.post(`${partnerApi.generateLink}${userId}`, {}, {
        headers: header
    });
    setTimeout(() => WebViewUtils.postMessageParentToChild(response.data), 0);
};
export const onTrackCustomerByToken = async (userId, network, asyncStorage, { instrumentTrack }) => {
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const trackingId = await AsyncStorage.getItem('trackingId');
    // !havePljFlag && instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_INITIATED',{trackingId:trackingId});
    const response = await network.post(`${partnerApi.getToken}${userId}`, {}, {
        headers: header
    });
    if (response?.status === 200) {
        // !havePljFlag && instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_COMPLETED',{trackingId:trackingId});
    }
    else {
        // !havePljFlag && instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_FAILED',{trackingId:trackingId});
    }
    setTimeout(() => WebViewUtils.postMessageParentToChild(response.data), 0);
};
export const generateShortTokenPlJ = async (userId, network, asyncStorage, { instrumentTrack, trackingId }) => {
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    await instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_INITIATED', { trackingId: trackingId });
    const response = await network.post(`${partnerApi.getToken}${userId}`, {}, {
        headers: header
    });
    if (response?.status === 200) {
        instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_COMPLETED', { trackingId: trackingId });
        return response.data;
    }
    else {
        instrumentTrack('PLJ_SHORT_TOKEN_GENERATION_FAILED', { trackingId: trackingId });
    }
};
export const LeadMobileCardBuilder = (mockDATA, partnerAccountType, partnerUserContext) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item?.borrowerAccountProfile.name ? item?.borrowerAccountProfile.name : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
            //status
            currentStepName: item.currentStepName ? item.currentStepName : '',
            //Available credit limit
            availableCreditAmount: item?.assetDetails?.availableCreditAmount ? item.assetDetails.availableCreditAmount : 'Pending',
            userData: item
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `leadsMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `leadsMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        const user = item;
        const currentStepName = item?.currentStepName;
        DATA_STORE = {
            ...DATA_STORE,
            [`leadsMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['name'] ?
                    partnerDetailCardObject['name'] :
                    showPhoneNumber(partnerAccountType) ? partnerDetailCardObject['phoneNumber'] :
                        `+91${maskSensitiveDetails(`${partnerDetailCardObject['phoneNumber']}`.slice(3), 0, 4)}`}`,
                detailItems: [
                    { title: 'Status', value: `${partnerDetailCardObject['currentStepName']}` },
                    { title: 'Available credit limit', value: partnerDetailCardObject['availableCreditAmount'] !== 'Pending' ? `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}` : partnerDetailCardObject['availableCreditAmount'] },
                ],
                actionItems: [
                    showViewDetails(partnerAccountType) ? {
                        title: 'View detail',
                        action: {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ? ACTION.CHECK_LIMIT_VIEW_DETAILS : ACTION.VIEW_DETAILS,
                            payload: {
                                user: partnerDetailCardObject['userData']
                            }
                        }
                    } : {},
                    (currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) ? {} : showShareLink(partnerUserContext) ? {
                        title: 'Share link',
                        action: {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: ACTION.SHARE_LINK,
                            payload: {
                                user: partnerDetailCardObject['userData']
                            }
                        }
                    } : {},
                    showMFDLedJourney(partnerAccountType) ? {
                        title: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ? 'Register customer' : 'Complete application',
                        action: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ?
                            {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: ACTION.ON_REGISTER_LEADS,
                                payload: {
                                    isPrevRouteLeads: true,
                                    preFill: true,
                                    pan: item?.borrowerAccountProfile?.panNumber,
                                    phoneNumber: item?.borrowerAccountProfile?.phoneNumber.slice(3)
                                },
                            } :
                            {
                                routeId: ROUTE.PARTNER_LEAD,
                                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                                payload: {
                                    value: partnerDetailCardObject['userData']
                                }
                            }
                    } : {},
                ]
            },
            [`leadsMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
export const ActiveCustomerCardBuilder = (mockDATA, partnerAccountType) => {
    console.log("Active customer card builder: ", mockDATA);
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item?.borrowerAccountProfile.name ? item?.borrowerAccountProfile.name : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
            //status
            availableLimit: item?.credit?.availableCreditAmount ? item?.credit?.availableCreditAmount : 0,
            //Available credit limit
            outStandingAmount: item?.credit?.principalOutStandingAmount ? item?.credit?.principalOutStandingAmount : 0,
            userData: item
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `activeCustomerMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `activeCustomerMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        DATA_STORE = {
            ...DATA_STORE,
            [`activeCustomerMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
                detailItems: [
                    { title: 'Available limit', value: `₹${addCommasToNumber(partnerDetailCardObject['availableLimit'])}` },
                    { title: 'Outstanding amount', value: `₹${addCommasToNumber(partnerDetailCardObject['outStandingAmount'])}` },
                ],
                actionItems: [
                    partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL ? {
                        title: 'View as client',
                        action: {
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                            payload: {
                                value: partnerDetailCardObject['userData']
                            }
                        }
                    } : {},
                    {
                        title: 'View detail',
                        action: {
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: partnerDetailCardObject['userData']
                            }
                        }
                    },
                ]
            },
            [`activeCustomerMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
export const rebuildLeadMobileCardBuilder = async (StandardUtilities, mockDATA, partnerAccountType, partnerUserContext) => {
    // rebuild the 'leadsMobCardStack'
    await StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'leadsMobCardStack', {
        widgetItems: [
            ...LeadMobileCardBuilder(mockDATA, partnerAccountType, partnerUserContext).WIDGET_STORE,
        ]
    });
    //we want to create the card component for each item
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        const user = item;
        const currentStepName = user?.currentStepName;
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item?.borrowerAccountProfile.name ? item?.borrowerAccountProfile.name : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
            //status
            currentStepName: item.currentStepName ? item.currentStepName : '',
            //Available credit limit
            availableCreditAmount: item?.assetDetails?.availableCreditAmount ? `${item?.assetDetails?.availableCreditAmount}` : 'Pending',
            userData: item
        };
        await StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `leadsMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['name'] ?
                partnerDetailCardObject['name'] :
                showPhoneNumber(partnerAccountType) ? partnerDetailCardObject['phoneNumber'] :
                    `+91${maskSensitiveDetails(`${partnerDetailCardObject['phoneNumber']}`.slice(3), 0, 4)}`}`,
            detailItems: [
                { title: 'Status', value: `${partnerDetailCardObject['currentStepName']}` },
                { title: 'Available credit limit', value: partnerDetailCardObject['availableCreditAmount'] !== 'Pending' ? `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}` : partnerDetailCardObject['availableCreditAmount'] },
            ],
            actionItems: [
                showViewDetails(partnerAccountType) ? {
                    title: 'View detail',
                    action: {
                        routeId: ROUTE.PARTNER_LEAD,
                        type: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ?
                            ACTION.CHECK_LIMIT_VIEW_DETAILS :
                            ACTION.VIEW_DETAILS,
                        payload: {
                            user: partnerDetailCardObject['userData']
                        }
                    }
                } : {},
                (currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */) ? {} : showShareLink(partnerUserContext) ? {
                    title: 'Share link',
                    action: {
                        routeId: ROUTE.PARTNER_LEAD,
                        type: ACTION.SHARE_LINK,
                        payload: {
                            user: partnerDetailCardObject['userData']
                        }
                    }
                } : {},
                showMFDLedJourney(partnerAccountType) && {
                    title: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ? 'Register customer' : 'Complete application',
                    action: currentStepName === "Pending registration" /* CurrentStepName.PENDING_REGISTRATION */ ?
                        {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: ACTION.ON_REGISTER_LEADS,
                            payload: {
                                isPrevRouteLeads: true,
                                preFill: true,
                                pan: item?.borrowerAccountProfile?.panNumber,
                                phoneNumber: item?.borrowerAccountProfile?.phoneNumber.slice(3)
                            },
                        } :
                        {
                            routeId: ROUTE.PARTNER_LEAD,
                            type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                            payload: {
                                value: partnerDetailCardObject['userData']
                            }
                        }
                },
            ]
        });
        await StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `leadsMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const rebuildActiveCustomerMobileCardBuilder = async (StandardUtilities, mockDATA, partnerAccountType) => {
    console.log("partnerAccountType active customer card:", partnerAccountType);
    // rebuild the 'leadsMobCardStack'
    await StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, 'activeCustomerMobCardStack', {
        widgetItems: ActiveCustomerCardBuilder(mockDATA, partnerAccountType).WIDGET_STORE,
    });
    //we want to create the card component for each item
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item?.borrowerAccountProfile.name ? item?.borrowerAccountProfile.name : '',
            phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
            //status
            availableLimit: item?.credit?.availableCreditAmount ? item?.credit?.availableCreditAmount : '',
            //Available credit limit
            outStandingAmount: item?.credit?.principalOutStandingAmount ? item?.credit?.principalOutStandingAmount : 0,
            userData: item
        };
        await StandardUtilities.setDatastore(ROUTE.PARTNER_ACTIVE_CUSTOMER, `activeCustomerMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
            detailItems: [
                { title: 'Available limit', value: `₹${addCommasToNumber(partnerDetailCardObject['availableLimit'])}` },
                { title: 'Outstanding amount', value: `₹${addCommasToNumber(partnerDetailCardObject['outStandingAmount'])}` },
            ],
            actionItems: [
                (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? {
                    title: 'View as client',
                    action: {
                        routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                        type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                        payload: {
                            value: partnerDetailCardObject['userData']
                        }
                    }
                } : {},
                {
                    title: 'View detail',
                    action: {
                        routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                        type: ACTION.VIEW_DETAILS,
                        payload: {
                            user: partnerDetailCardObject['userData']
                        }
                    }
                },
            ]
        });
        await StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `activeCustomerMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const ReferredPartnerMobileCardBuilder = (mockDATA) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            partnerName: item?.partnerName ? item?.partnerName : '',
            partnerMobileNumber: item?.partnerMobileNumber
                ? item?.partnerMobileNumber
                : '',
            partnerActivationStatus: item?.partnerActivationStatus,
            empanelmentDate: item?.empanelmentDate
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        const { date, month, year } = convertISODate(partnerDetailCardObject['empanelmentDate']);
        DATA_STORE = {
            ...DATA_STORE,
            [`ReferredPartnerMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['partnerName']}`,
                detailItems: [
                    { title: 'Contact no', value: `${partnerDetailCardObject['partnerMobileNumber']}` },
                    { title: 'Status', value: `${partnerDetailCardObject['partnerActivationStatus']}` },
                    { title: 'Date of empanelment', value: `${date} ${month.slice(0, 3)} ${year}` },
                ],
                actionItems: []
            },
            [`ReferredPartnerMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
export const rebuildReferredPartnerMobileCardBuilder = async (StandardUtilities, mockDATA) => {
    await StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, 'referredPartnerCardStack', {
        widgetItems: ReferredPartnerMobileCardBuilder(mockDATA).WIDGET_STORE,
    });
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            partnerName: item?.partnerName ? item?.partnerName : '',
            partnerMobileNumber: item?.partnerMobileNumber
                ? item?.partnerMobileNumber
                : '',
            partnerActivationStatus: item?.partnerActivationStatus,
            empanelmentDate: item?.empanelmentDate
        };
        const { date, month, year } = convertISODate(partnerDetailCardObject['empanelmentDate']);
        await StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, `ReferredPartnerMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['partnerName'] ? partnerDetailCardObject['partnerName'] : partnerDetailCardObject['phoneNumber']}`,
            detailItems: [
                { title: 'Contact no', value: `${partnerDetailCardObject['partnerMobileNumber']}` },
                { title: 'Status', value: `${partnerDetailCardObject['partnerActivationStatus']}` },
                { title: 'Date of empanelment', value: `${date} ${month.slice(0, 3)} ${year}` },
            ],
            actionItems: []
        });
        await StandardUtilities.setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, `ReferredPartnerMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const getEpochTime = (epochTimestamp) => {
    console.warn("epoachTIme", epochTimestamp);
    const date = new Date(epochTimestamp); // Convert to milliseconds
    const formattedTime = date.toLocaleString('en-IN', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
    return formattedTime;
};
export const EarningTableDataBuilder = (mockDATA, partnerAccountType) => {
    mockDATA = [];
    const DATA = {
        // selectMap: [],
        year: [],
        month: [],
        new_accounts_opened: [],
        total_accounts_opened: [],
        loan_outstanding: [],
        trial_earning: [],
        upfront_earning: [],
        total_earning: []
    };
    const Title_MAP = {
        // selectMap: '',
        // name: 'Name',
        // panNumber: 'PAN',
        // phoneNumber: 'Mobile',
        // emailId: 'Email',
        // currentStepName: 'Application status',
        // createdOn: 'Created on',
        year: 'YEAR',
        month: 'MONTH',
        new_accounts_opened: 'NEW ACCOUNTS OPENED',
        total_accounts_opened: 'TOTAL ACCOUNTS OPENED',
        loan_outstanding: 'LOAN OUTSTANDING',
        trial_earning: 'TRAIL EARNING',
        upfront_earning: 'UPFRONT EARNING',
        total_earning: 'TOTAL EARNING'
    };
    let DATA_STORE = {};
    const TITLE_CONFIG = {
        year: {
            title: 'YEAR',
            flex: 1,
        },
        month: {
            title: 'MONTH',
            flex: 1,
        },
        new_accounts_opened: {
            title: 'NEW ACCOUNTS OPENED',
            flex: 2,
        },
        total_accounts_opened: {
            title: 'AVAILABLE CREDIT AMOUNT',
            flex: 2,
        },
        loan_outstanding: {
            title: 'LOAN OUTSTANDING',
            flex: 2,
        },
        trial_earning: {
            title: 'TRAIL EARNING',
            flex: 2,
        },
        upfront_earning: {
            title: 'UPFRONT EARNING',
            flex: 2,
        },
        total_earning: {
            title: 'TOTAL EARNING',
            flex: 2,
        },
    };
    console.log('*** mockDATA ***: ', mockDATA);
    const TABLE_DATA = [];
    // mockDATA.forEach((item, index_i) => {
    //     let tableObject = {}
    //     tableObject = {
    //         name: item?.borrowerAccountProfile.name
    //             ? item?.borrowerAccountProfile.name
    //             : '',
    //         phoneNumber: item?.borrowerAccountProfile?.phoneNumber
    //             ? item?.borrowerAccountProfile?.phoneNumber
    //             : '',
    //         totalPortfolioAmount: item?.assetDetails.totalPortfolioAmount | 0,
    //         availableCreditAmount: item?.assetDetails.availableCreditAmount | 0,
    //         currentStepName: item.currentStepName ? item.currentStepName : '',
    //         createdOn: item?.lastUpdatedOn,
    //         lastUpdatedOn: item?.lastUpdatedOn,
    //         // customerJourney: item?.borrowerAccountProfile.userId,
    //         customerJourney: item,
    //     }
    //     TABLE_DATA.push(tableObject)
    //     Object.keys(DATA).forEach((fieldName, index_j) => {
    //         if (fieldName === 'selectMap') {
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.RADIO,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <RadioProps & WidgetProps>{
    //                     isChecked: false,
    //                     size: IconSizeTokens.MD,
    //                     actionChecked: {
    //                         type: ACTION.ON_SELECT,
    //                         routeId: ROUTE.PARTNER_LEAD,
    //                         payload: <SelectActionPayload>{ data: item },
    //                     },
    //                     actionUnChecked: {
    //                         type: ACTION.ON_SELECT,
    //                         routeId: ROUTE.PARTNER_LEAD,
    //                         payload: <SelectActionPayload>{ data: item },
    //                     },
    //                 },
    //             }
    //         } else if (fieldName === 'currentStepName') {
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.STACK,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <StackProps>{
    //                     type: StackType.row,
    //                     // bgColor: ColorTokens.Grey_Chalk,
    //                     // justifyContent: StackJustifyContent.flexStart,
    //                     // alignItems: StackAlignItems.center,
    //                     borderConfig: {
    //                         borderRadius: BorderRadiusTokens.BR1,
    //                     },
    //                     // padding: {
    //                     //     vertical: SizeTypeTokens.MD,
    //                     //     left: SizeTypeTokens.MD,
    //                     // },
    //                     widgetItems: [
    //                         // { id: `icon_${fieldName}_${index_i}`, type: WIDGET.ICON },
    //                         // { id: `leads_status_space_${fieldName}_${index_i}`, type: WIDGET.SPACE },
    //                         {
    //                             id: `statusTitle_${fieldName}_${index_i}`,
    //                             type: WIDGET.TEXT,
    //                         },
    //                     ],
    //                 },
    //                 // [`leads_status_space_${fieldName}_${index_i}`]: <SpaceProps>{
    //                 //     size: SizeTypeTokens.MD
    //                 // },
    //                 // [`icon_${fieldName}_${index_i}`]:<IconProps> {
    //                 //     name: IconTokens.Dot,
    //                 //     label: IconTokens.Dot,
    //                 //     size: IconSizeTokens.XXL
    //                 // },
    //                 [`statusTitle_${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `${tableObject[fieldName]}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else if (
    //             fieldName === 'totalPortfolioAmount' ||
    //             fieldName === 'availableCreditAmount'
    //         ) {
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.STACK,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <StackProps>{
    //                     type: StackType.row,
    //                     justifyContent: StackJustifyContent.flexEnd,
    //                     alignItems: StackAlignItems.center,
    //                     widgetItems: [
    //                         {
    //                             id: `amountLeads_${fieldName}_${index_i}`,
    //                             type: WIDGET.TEXT,
    //                         },
    //                     ],
    //                 },
    //                 [`amountLeads_${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `₹${addCommasToNumber(tableObject[fieldName])}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else if (fieldName === 'createdOn') {
    //             const { date, month, year } = convertISODate(
    //                 tableObject[fieldName],
    //             )
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.TEXT,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `${date} ${month.slice(0, 3)}, ${year}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else if (fieldName === 'lastUpdatedOn') {
    //             const { date, month, year } = convertISODate(
    //                 tableObject[fieldName],
    //             )
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.TEXT,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `${date} ${month.slice(0, 3)}, ${year}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else if (fieldName === 'phoneNumber') {
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.TEXT,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: showPhoneNumber(partnerAccountType) ?
    //                         `${tableObject[fieldName]}`.slice(3) :
    //                         `+91${maskSensitiveDetails(`${tableObject[fieldName]}`.slice(3), 0, 3)}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else if (fieldName === 'customerJourney') {
    //
    //             const _user = tableObject[fieldName];
    //
    //             const currentStepName = _user?.currentStepName;
    //
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.STACK,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <StackProps & WidgetProps>{
    //                     type: StackType.column,
    //                     alignItems: StackAlignItems.flexStart,
    //                     justifyContent: StackJustifyContent.center,
    //                     padding: {
    //                         top: SizeTypeTokens.XS,
    //                         left: SizeTypeTokens.XS,
    //                         bottom: SizeTypeTokens.XS,
    //                     },
    //                     widgetItems: [
    //                         partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL ? {
    //                             id: `trackbutton_Stack_${fieldName}_${index_i}`,
    //                             type: WIDGET.STACK,
    //                         } : {},
    //                         currentStepName !== CurrentStepName.PENDING_REGISTRATION ? {
    //                             id: `shareLink_Stack_${fieldName}_${index_i}`,
    //                             type: WIDGET.STACK,
    //                         } : {},
    //                         currentStepName !== CurrentStepName.PENDING_REGISTRATION ? {
    //                             id: `viewDetail_Stack_${fieldName}_${index_i}`,
    //                             type: WIDGET.STACK,
    //                         }: {},
    //                     ],
    //                     // action: {
    //                     //     routeId: ROUTE.PARTNER_LEAD,
    //                     //     type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
    //                     //     payload: {
    //                     //         value: tableObject[fieldName],
    //                     //     },
    //                     // },
    //                 },
    //                 [`trackbutton_Stack_${fieldName}_${index_i}`]: <StackProps & WidgetProps>{
    //                     type: StackType.row,
    //                     widgetItems: [
    //                         { id: `trackbutton_${fieldName}_${index_i}`, type: WIDGET.TEXT }
    //                     ],
    //                     padding: {
    //                         top: SizeTypeTokens.SM,
    //                         bottom: SizeTypeTokens.SM
    //                     },
    //                     action: currentStepName === CurrentStepName.PENDING_REGISTRATION ?
    //                         {
    //                             routeId: ROUTE.PARTNER_LEAD,
    //                             type: ACTION.ON_REGISTER_LEADS,
    //                             payload: {
    //                                 isPrevRouteLeads: true,
    //                                 preFill: true,
    //                                 pan: _user?.borrowerAccountProfile?.panNumber,
    //                                 phoneNumber: _user?.borrowerAccountProfile?.phoneNumber.slice(3)
    //                                 // value: tableObject[fieldName],
    //                             },
    //                         }
    //                         : {
    //                             routeId: ROUTE.PARTNER_LEAD,
    //                             type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
    //                             payload: {
    //                                 value: tableObject[fieldName],
    //                             },
    //                         },
    //                 },
    //                 [`shareLink_Stack_${fieldName}_${index_i}`]: <StackProps & WidgetProps>{
    //                     type: StackType.row,
    //                     widgetItems: [
    //                         { id: `shareLink_${fieldName}_${index_i}`, type: WIDGET.TEXT }
    //                     ],
    //                     padding: {
    //                         top: SizeTypeTokens.SM,
    //                         bottom: SizeTypeTokens.SM
    //                     },
    //                     action: {
    //                         routeId: ROUTE.PARTNER_LEAD,
    //                         type: ACTION.SHARE_LINK,
    //                         payload: {
    //                             user: tableObject[fieldName],
    //                         },
    //                     },
    //                 },
    //                 [`viewDetail_Stack_${fieldName}_${index_i}`]: <StackProps & WidgetProps>{
    //                     type: StackType.row,
    //                     widgetItems: [
    //                         { id: `viewDetails_${fieldName}_${index_i}`, type: WIDGET.TEXT }
    //                     ],
    //                     padding: {
    //                         top: SizeTypeTokens.SM,
    //                         bottom: SizeTypeTokens.SM
    //                     },
    //                     action: {
    //                         routeId: ROUTE.PARTNER_LEAD,
    //                         type: ACTION.VIEW_DETAILS,
    //                         payload: {
    //                             user: tableObject[fieldName],
    //                         },
    //                     },
    //                 },
    //                 [`trackbutton_${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: currentStepName !== CurrentStepName.PENDING_REGISTRATION ? `MFD led journey \u276F` : `EmptyEarning \u276F`,
    //                     fontSize: FontSizeTokens.SM,
    //                     fontWeight: '600',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Primary_100,
    //                     lineHeight: 18,
    //                 },
    //                 [`shareLink_${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `Share link \u276F`,
    //                     fontSize: FontSizeTokens.SM,
    //                     fontWeight: '600',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Primary_100,
    //                     lineHeight: 18,
    //                 },
    //                 [`viewDetails_${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `View details \u276F`,
    //                     fontSize: FontSizeTokens.SM,
    //                     fontWeight: '600',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Primary_100,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         } else {
    //             DATA[fieldName].push({
    //                 id: `${fieldName}_${index_i}`,
    //                 type: WIDGET.TEXT,
    //             })
    //             DATA_STORE = {
    //                 ...DATA_STORE,
    //                 [`${fieldName}_${index_i}`]: <TypographyProps>{
    //                     label: `${tableObject[fieldName]}`,
    //                     fontSize: FontSizeTokens.XS,
    //                     fontWeight: '400',
    //                     fontFamily: FontFamilyTokens.Inter,
    //                     color: ColorTokens.Grey_Night,
    //                     lineHeight: 18,
    //                 },
    //             }
    //         }
    //     })
    // })
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
export const ShowNewRmContactButton = async () => {
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    const fetchedConfig = await AsyncStorage.getItem("remoteConfig");
    let configData;
    if (fetchedConfig) {
        configData = JSON.parse(fetchedConfig);
    }
    else
        return false;
    const test_numbers_rm = await configData?.show_rm_contact_button_test_number;
    if (!test_numbers_rm) {
        return false;
    }
    const test_numbers_rm_object = JSON.parse(test_numbers_rm);
    const show_rm_test_phoneNumbers = test_numbers_rm_object?.numbers
        ? test_numbers_rm_object?.numbers
        : [];
    const showNewRmContactButton = configData?.show_rm_contact_button;
    if (showNewRmContactButton &&
        (showNewRmContactButton === true ||
            showNewRmContactButton === "true")) {
        return true;
    }
    else {
        return show_rm_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const getCardDataFromFireBase = async () => {
    const partner_dashboard_card_details = await sharedPropsService.getFirebaseConfig()?.partner_dashboard_card_details;
    let partner_dashboard_card_details_JSON;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    if (partner_dashboard_card_details) {
        partner_dashboard_card_details_JSON = JSON.parse(partner_dashboard_card_details);
        const show_Feature_Master_Flag = partner_dashboard_card_details_JSON?.show_Feature_Master_Flag;
        const test_numbers = partner_dashboard_card_details_JSON?.test_numbers;
        if (show_Feature_Master_Flag === true ||
            show_Feature_Master_Flag === "true") {
            if (test_numbers?.includes(userPhoneNumber?.slice(3))) {
                return partner_dashboard_card_details_JSON?.test_Data;
            }
            else {
                return partner_dashboard_card_details_JSON?.prod_Data;
            }
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
};
export const getReferredPartnerCardDataFromFireBase = async () => {
    const partner_dashboard_card_details = await sharedPropsService.getFirebaseConfig()?.partner_referred_partner_card_details;
    let partner_dashboard_card_details_JSON;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    if (partner_dashboard_card_details) {
        partner_dashboard_card_details_JSON = JSON.parse(partner_dashboard_card_details);
        const show_Feature_Master_Flag = partner_dashboard_card_details_JSON?.show_Feature_Master_Flag;
        const test_numbers = partner_dashboard_card_details_JSON?.test_numbers;
        if (show_Feature_Master_Flag === true ||
            show_Feature_Master_Flag === "true") {
            if (test_numbers?.includes(userPhoneNumber?.slice(3))) {
                return partner_dashboard_card_details_JSON?.test_Data;
            }
            else {
                return partner_dashboard_card_details_JSON?.prod_Data;
            }
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
};
export const getRewardStructureCardDataFromFireBase = async () => {
    const partner_dashboard_card_details = await sharedPropsService.getFirebaseConfig()?.partner_referred_partner_reward_structure;
    let partner_dashboard_card_details_JSON;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    let rewardStructureData = undefined;
    let rewardStructureImageUrl = undefined;
    if (partner_dashboard_card_details) {
        partner_dashboard_card_details_JSON = JSON.parse(partner_dashboard_card_details);
        const test_numbers = partner_dashboard_card_details_JSON?.test_numbers;
        if (test_numbers?.includes(userPhoneNumber?.slice(3))) {
            rewardStructureData = partner_dashboard_card_details_JSON?.test_Data.data;
            rewardStructureImageUrl = partner_dashboard_card_details_JSON?.test_Data?.imageUrl;
            return {
                rewardStructureData,
                rewardStructureImageUrl
            };
        }
        else {
            rewardStructureData = partner_dashboard_card_details_JSON?.prod_Data.data;
            rewardStructureImageUrl = partner_dashboard_card_details_JSON?.prod_Data?.imageUrl;
            return {
                rewardStructureData,
                rewardStructureImageUrl
            };
            return partner_dashboard_card_details_JSON?.prod_Data?.data;
        }
    }
    else {
        return {
            rewardStructureData,
            rewardStructureImageUrl
        };
    }
};
export const getReferredPartnerSideNavTitle = async () => {
    const partner_referred_partner_sidenav_title = await sharedPropsService.getFirebaseConfig()?.partner_referred_partner_sidenav_title;
    let partner_referred_partner_sidenav_title_JSON;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    if (partner_referred_partner_sidenav_title) {
        partner_referred_partner_sidenav_title_JSON = JSON.parse(partner_referred_partner_sidenav_title);
        const test_numbers = partner_referred_partner_sidenav_title_JSON?.test_numbers;
        if (test_numbers?.includes(userPhoneNumber?.slice(3))) {
            return partner_referred_partner_sidenav_title_JSON?.test_Data;
        }
        else {
            return partner_referred_partner_sidenav_title_JSON?.prod_Data;
        }
    }
    else {
        return "";
    }
};
export const getReferredPartnerMobileNavTitle = async () => {
    const partner_referred_partner_sidenav_title = await sharedPropsService.getFirebaseConfig()?.partner_referred_partner_mobilenav_title;
    let partner_referred_partner_sidenav_title_JSON;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const userPhoneNumber = userData?.user?.phoneNumber;
    if (partner_referred_partner_sidenav_title) {
        partner_referred_partner_sidenav_title_JSON = JSON.parse(partner_referred_partner_sidenav_title);
        const test_numbers = partner_referred_partner_sidenav_title_JSON?.test_numbers;
        if (test_numbers?.includes(userPhoneNumber?.slice(3))) {
            return partner_referred_partner_sidenav_title_JSON?.test_Data;
        }
        else {
            return partner_referred_partner_sidenav_title_JSON?.prod_Data;
        }
    }
    else {
        return "";
    }
};
